import React from "react";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import Profile from "pages/Profile";
import { MainPage } from "pages/MainPage";

const ProfilePageWithFeatureFlag = () => {
  const isProfileRedesignEnabled = useLaunchDarklyFlags(
    FEATURE_FLAGS.ProfileRedesign
  );

  return isProfileRedesignEnabled ? <Profile /> : <MainPage />;
};

export default ProfilePageWithFeatureFlag;
